export default "__VITE_PUBLIC_ASSET__1b3a9043__"